import { useApiGet } from "@/hooks/useApi";
import { getAllCourses } from "../api";

export function useGetAllCourses() {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["courses", "list", "all"],
		fn: getAllCourses,
	});

	const { courses, categories } = data || { courses: [], categories: [] };

	return { courses, categories, isPending, isSuccess, isError, error };
}
